import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

export const getELibraryConfig = (): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			headerImage: '/svg/library.svg',
			title: 'Welcome to the eLibrary',
			subtitle: "Browse the wide range of Little Learners' decodable books and use them for whole-class teaching",
			button: {
				label: 'Show me around',
				type: 'full-width' as const,
				hasBackButton: false
			},
			modalPosition: 'center' as const,
			hasBackdrop: true
		},
		{
			type: 'modal' as const,
			title: 'Decodable books based on the Little Learners Scope and Sequence',
			subtitle:
				'Books are divided into Stages and series based on the Little Learners scope and sequence - where each stage focuses on different phonemes and graphemes\n\nWe’ve made it easier to familiarise each Stage by showing the focus listed in each section.',
			image: '/img/ftux-eLibrary-1.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: false
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#stage-1',
			subtitle: 'Click a stage to expand and view the books and series available for that stage.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#book-card-0',
			subtitle:
				'Books are labelled with their title and cover. You can also add books to favourites to quickly find books you are progressing through for later.',
			tooltipPlacement: 'right' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#filter-stage',
			subtitle:
				'Quickly navigate to a Stage using the stage dropdown or search for a book by title. You can also use the favourites toggle to view any of your favourited books.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'eLibrary-ftux',
		name: 'eLibrary Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
